import { render, staticRenderFns } from "./CharactersEdit.vue?vue&type=template&id=8c7630de&scoped=true&"
import script from "./CharactersEdit.vue?vue&type=script&lang=js&"
export * from "./CharactersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7630de",
  null
  
)

export default component.exports